import { c as _c } from "react/compiler-runtime";
import { Elements } from '@stripe/react-stripe-js';
import { Stripe, loadStripe } from '@stripe/stripe-js';
import { getStripeSupportedLocale } from 'modules/profile/user-plan/utils/user-plan-stripe-utils';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import useUser from 'shared/hooks/use-user';
const StripeWrapper = t0 => {
  const $ = _c(10);
  const {
    children
  } = t0;
  const [stripe, setStripe] = useState(null);
  const {
    user
  } = useUser();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (process.env.NEXT_PUBLIC_STRIPE_API_KEY_PUBLIC) {
        const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_API_KEY_PUBLIC, {
          stripeAccount: process.env.NEXT_PUBLIC_STRIPE_ACCOUNT_ID
        });
        setStripe(stripePromise);
      }
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== user) {
    t3 = user?.dashboardLocale && getStripeSupportedLocale(user.dashboardLocale);
    $[2] = user;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = {
      locale: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== stripe || $[8] !== t4) {
    t5 = <Elements stripe={stripe} options={t4}>{children}</Elements>;
    $[6] = children;
    $[7] = stripe;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default StripeWrapper;